import Discord from '../assets/Discord.png';
import { useState, memo } from 'react';
import HelpButton from '../buttons/HelpButton';
import MembersButton from '../buttons/MembersButton';
import OwnersButton from '../buttons/OwnersButton';
import { useCurrentWidth } from 'react-socks';
import { ClickAwayListener, Grow, Paper, Popper } from '@mui/material';
import React from 'react';
import { getBannerType } from '../utilities/imageUtils';
import SignInButton from '../buttons/SignInButton';
import HomeButton from '../buttons/HomeButton';
import Tumblr from '../assets/tumblr.svg'

const GuestBanner = ({ loginCallback }: { loginCallback: () => void }): JSX.Element | null => {
    const width = useCurrentWidth();
    const [showMobilePopper, setShowMobilePopper] = useState(false);
    const anchorRef = React.useRef<HTMLButtonElement>(null);
    const popperRef = React.useRef(null);

    const isBrowserMode = width > 750;
    return (
        <div style={{ position: 'sticky', top: 0, zIndex: 2, background: '#26272e' }}>
            <div className={isBrowserMode ? 'bannerComponent' : 'mobileBannerComponent'}>
                {isBrowserMode && width > 1250
                    && <img alt="banner" src={getBannerType()} className='bannerSplash' />}
                <div style={{
                    display: 'flex',
                    flexWrap: 'wrap',
                    marginTop: 15,
                    flexFlow: 'row wrap',
                    width: '100%',
                }}>
                    {/* constant buttons */}
                    <HomeButton isAdmin={true} ownsSessions={false} />
                    {isBrowserMode && <MembersButton onClick={() => setShowMobilePopper(false)} />}
                    {isBrowserMode && <OwnersButton onClick={() => setShowMobilePopper(false)} />}
                    {isBrowserMode && <HelpButton />}
                    <SignInButton loginCallback={loginCallback} />
                </div>
                {isBrowserMode && width > 1250 && <a href="https://discord.gg/M3NpQF7DwH" rel="noopener noreferrer" target="_blank"><img src={Discord} width={120} height={45} style={{ position: 'absolute', right: 105, top: 20 }} /></a>}
                {isBrowserMode && width > 1250 && <a href="https://www.tumblr.com/tarlingsstore" rel="noopener noreferrer" target="_blank"><img src={Tumblr} width={150} height={40} style={{ position: 'absolute', right: 175, top: 20 }} /></a>}
            </div>
            <Popper
                open={showMobilePopper} anchorEl={anchorRef.current} popperRef={popperRef} style={{ zIndex: 999 }}
                role={undefined} transition disablePortal
            >
                {({ TransitionProps, placement }) => (
                    <Grow
                        {...TransitionProps}
                        style={{
                            transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom',
                        }}
                    >
                        <Paper className='mobilePopperButtonsPaper'>
                            <ClickAwayListener onClickAway={() => setShowMobilePopper(false)}>
                                <div className='mobilePopperButtonsContainer'>
                                    {/* exploring buttons */}
                                    {<MembersButton onClick={() => setShowMobilePopper(false)} />}
                                    {<OwnersButton onClick={() => setShowMobilePopper(false)} />}
                                    <HelpButton />
                                </div>
                            </ClickAwayListener>
                        </Paper>
                    </Grow>
                )}
            </Popper>
        </div >
    )
};

export default memo(GuestBanner);